import * as R from 'ramda'
// @ts-ignore
import { createAction } from 'redux-actions'
import {
  EventMessageActionPayload,
  MessageActionTypes,
} from '@weblite/ts-action/message'
import { dispatch } from '$setup/redux'

export interface MessageActionItem {
  userId: string
  action: MessageActionTypes
}

type MessageActionState = Record<string, MessageActionItem[]>

const initialState: MessageActionState = {}

// reducer
const INSERT_MESSAGE_ACTION = 'INSERT_MESSAGE_ACTION'
const insertMessageAction = createAction(INSERT_MESSAGE_ACTION)

const REMOVE_MESSAGE_ACTION = 'REMOVE_MESSAGE_ACTION'
const removeMessageAction = createAction(REMOVE_MESSAGE_ACTION)

// reducers
const reducers = {
  [INSERT_MESSAGE_ACTION]: (
    state: MessageActionState,
    {
      roomId,
      messageActionItem,
    }: { roomId: string; messageActionItem: MessageActionItem },
  ): MessageActionState =>
    R.ifElse(
      R.has(roomId),
      R.over(
        R.lensPath([roomId]),
        R.unless(
          R.find(R.equals(messageActionItem)) as any,
          R.append(messageActionItem),
        ),
      ),
      R.assoc(roomId, [messageActionItem]),
    )(state),

  [REMOVE_MESSAGE_ACTION]: (
    state: MessageActionState,
    {
      roomId,
      messageActionItem,
    }: { roomId: string; messageActionItem: MessageActionItem },
  ): MessageActionState => {
    const roomActionsList = state[roomId] || []

    if (!roomActionsList?.length) return state
    const selectedAction = R.find(R.equals(messageActionItem), roomActionsList)

    if (selectedAction)
      return {
        ...state,
        [roomId]: R.without([selectedAction], roomActionsList),
      }
    return state
  },
}

export const messageActionStorage = {
  insertMessageAction: ({
    roomId,
    ...messageActionItem
  }: EventMessageActionPayload) =>
    dispatch(insertMessageAction({ roomId, messageActionItem })),

  removeMessageAction: ({
    roomId,
    ...messageActionItem
  }: EventMessageActionPayload) =>
    dispatch(removeMessageAction({ roomId, messageActionItem })),
}

export const messageActionReducer = (
  state = initialState,
  {
    type,
    payload,
  }: {
    type: keyof typeof reducers
    payload: { roomId: string; messageActionItem: MessageActionItem } & string
  },
) => (reducers[type] ? reducers[type](state, payload) : state)
